export { default } from './P20InstagramWall';
